export const deepLinkingScheme = 'plumvillage://'



// WEBPACK FOOTER //
// ./src/config/settings.js